var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('half-circle-spinner',{staticClass:"spinner",attrs:{"animation-duration":1000,"size":30,"color":"#ed4040"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }